import { useRef, useEffect } from 'react';
import autoAnimate from '../index.mjs';
/**
 * AutoAnimate hook for adding dead-simple transitions and animations to react.
 * @param options - Auto animate options or a plugin
 * @returns
 */

function useAutoAnimate() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var element = useRef(null);
  useEffect(function () {
    if (element.current instanceof HTMLElement) autoAnimate(element.current, options);
  }, [element]);
  return [element];
}

export { useAutoAnimate };